module.exports = __webpack_public_path__ + "img/board_bg.c468e213.jpg";